import type { ApiResponse } from '@/lib/apiClient';
import { apiClient } from '@/lib/apiClient';
import type { MutationOptions } from '@/lib/reactQuery';
import { useMutation } from '@tanstack/react-query';

interface RegisterBody {
  username: string;
  password: string;
  invitationToken: string;
}

type RegisterResponse = ApiResponse<{
  user: unknown;
}>;

export const register = async ({ username, password, invitationToken }: RegisterBody) => {
  const response = await apiClient.post<RegisterResponse>(`/v1/auth/register`, {
    username,
    password,
    invitationToken,
  });
  return response.data;
};

interface UseRegisterOptions {
  options?: MutationOptions<RegisterResponse, RegisterBody>;
}

export const REGISTER_QUERY_KEY = 'register';

export const useRegister = ({ options }: UseRegisterOptions) => {
  return useMutation({
    mutationKey: [REGISTER_QUERY_KEY],
    mutationFn: register,
    ...options,
  });
};
